import { ROUTE_LABELS } from '@app/router/constants';

import { AccountType, Locale } from '@mfe/shared/schema-types';

import { ProductInstanceTypes } from '../../../../platform/src/server/dataSources/PSM/types';
import { UserType } from './types';

// Helper function to determine user type based on product kind and fiber status
export const getUserType = (productKind?: string | null): UserType => {
  if (productKind === ProductInstanceTypes.Fiber) {
    return UserType.Fiber;
  }

  if (productKind === ProductInstanceTypes.WirelessInternet) {
    return UserType.FixedWireless;
  }

  return UserType.Default;
};

// Helper function to check if FAQs should be shown
export const shouldShowFAQs = (userLocale: Locale, accountType: AccountType) => {
  return userLocale === Locale.EnUs && accountType === AccountType.Residential;
};

// Helper function to get route label with fallback
export const getRouteLabel = (path: string, t: (key: string) => string) =>
  t(ROUTE_LABELS[path as keyof typeof ROUTE_LABELS] || 'Unknown');
